<template>

    <loader v-if="isLoading == true" name="spinning" loadingText="Cargando..." textColor="#ffffff" textSize="20" textWeight="500" object="#ff9633" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" :disableScrolling="true"></loader>

    <h3 style="text-align: left;">Datos del oficio resolutivo</h3>
    <p style="text-align: left;" class="text-muted">
        Captura la información tal como aparece en el oficio emitido por la dependencia (CFE / CENACE / CNE).
    </p>

    <!-- Identificación del oficio -->
    <div class="col-md-12 row">
        <div class="col-md-4">
            <label for="numero_oficio">No. de oficio resolutivo <span class="text-danger">*</span></label>
            <input
                id="numero_oficio"
                class="form-control"
                type="text"
                v-model="numero_oficio"
                :disabled="sin_numero"
                placeholder="Ej. ZMR-PLA/0659/2026"
            />
            <div class="form-check mt-1" style="text-align: left;">
                <input class="form-check-input" type="checkbox" id="sin_numero" v-model="sin_numero" @change="cambiarSinNumero" />
                <label class="form-check-label" for="sin_numero">Sin número (S/N)</label>
            </div>
        </div>
        <div class="col-md-3">
            <label for="fecha_emision">Fecha de emisión <span class="text-danger">*</span></label>
            <input id="fecha_emision" class="form-control" type="date" v-model="fecha_emision" />
        </div>
        <div class="col-md-3">
            <label for="dependencia">Dependencia que lo emite <span class="text-danger">*</span></label>
            <select id="dependencia" class="form-control" v-model="dependencia">
                <option value="">Seleccione</option>
                <option v-for="item in dependencias" :key="item" :value="item">{{ item }}</option>
            </select>
        </div>
    </div>

    <!-- División y zona -->
    <div class="col-md-12 row">
        <div class="col-md-4">
            <label for="division">División <span class="text-danger">*</span></label>
            <input id="division" class="form-control" type="text" v-model="division" placeholder="Ej. Jalisco" />
        </div>
        <div class="col-md-4">
            <label for="zona">Zona <span class="text-danger">*</span></label>
            <input id="zona" class="form-control" type="text" v-model="zona" placeholder="Ej. Reforma" />
        </div>
    </div>
    <hr>

    <!-- Datos técnicos -->
    <h3 style="text-align: left;">Datos técnicos de la central</h3>
    <div class="col-md-12 row">
        <div class="col-md-3">
            <label for="capacidad">Capacidad <span class="text-danger">*</span></label>
            <div class="input-group">
                <input id="capacidad" class="form-control" type="number" min="0" step="any" v-model="capacidad" />
                <select class="form-select" style="max-width: 90px;" v-model="unidad_capacidad">
                    <option value="kW">kW</option>
                    <option value="MW">MW</option>
                </select>
            </div>
        </div>
        <div class="col-md-3">
            <label for="tension_conexion">Tensión de conexión (kV) <span class="text-danger">*</span></label>
            <input id="tension_conexion" class="form-control" type="number" min="0" step="any" v-model="tension_conexion" />
        </div>
        <div class="col-md-4">
            <label for="tecnologia">Tipo de tecnología <span class="text-danger">*</span></label>
            <select id="tecnologia" class="form-control" v-model="tecnologia">
                <option value="">Seleccione una tecnología</option>
                <option v-for="item in tecnologias" :key="item" :value="item">{{ item }}</option>
            </select>
        </div>
    </div>
    <br>

    <div class="col-md-12">
        <button v-if="botonGuardar == true" type="button" class="button btn" style="background-color: #F49315; color: white;" @click="submitForm()">Guardar Oficio Resolutivo</button>
        <button v-else type="button" class="button btn btn-warning" @click="submitFormActualizar()">Actualizar Oficio Resolutivo</button>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import loader from "vue3-ui-preloader";

export default {
    components: {
        loader
    },
    data() {
        return {
            isLoading: false,
            id: '',
            numero_oficio: '',
            sin_numero: false,
            fecha_emision: '',
            dependencia: '',
            division: '',
            zona: '',
            capacidad: '',
            unidad_capacidad: 'kW',
            tension_conexion: '',
            tecnologia: '',
            botonGuardar: true,
            dependencias: ['CFE', 'CENACE'],
            tecnologias: [
                'Bioenergía',
                'Carboeléctrica',
                'Ciclo Combinado',
                'Cogeneración',
                'Cogeneración Eficiente',
                'Combustión Interna',
                'Combustión Interna y Fotovoltaica',
                'Energía Cinética',
                'Eólica',
                'Fotovoltaica',
                'Geotérmica',
                'Hidroeléctrica',
                'Lecho Fluidizado',
                'Nucleoeléctrica',
                'Termoeléctrica Convencional',
                'Turbogás',
                'Centro de Carga'
            ]
        }
    },
    created() {
        this.mostrarInformacion();
    },
    methods: {
        config() {
            const token = localStorage.getItem('accessToken');
            return {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                }
            };
        },
        cambiarSinNumero() {
            this.numero_oficio = this.sin_numero ? 'S/N' : '';
        },
        validar() {
            const faltantes = [];
            if (!this.numero_oficio) faltantes.push('No. de oficio');
            if (!this.fecha_emision) faltantes.push('Fecha de emisión');
            if (!this.dependencia) faltantes.push('Dependencia');
            if (!this.division) faltantes.push('División');
            if (!this.zona) faltantes.push('Zona');
            if (this.capacidad === '' || this.capacidad === null) faltantes.push('Capacidad');
            if (this.tension_conexion === '' || this.tension_conexion === null) faltantes.push('Tensión de conexión');
            if (!this.tecnologia) faltantes.push('Tipo de tecnología');

            if (faltantes.length > 0) {
                Swal.fire('Faltan datos', 'Completa: ' + faltantes.join(', '), 'warning');
                return false;
            }
            return true;
        },
        armarDatos() {
            return {
                numero_oficio: this.sin_numero ? 'S/N' : this.numero_oficio.trim(),
                fecha_oficio: this.fecha_emision,
                emitido_por: this.dependencia,
                division: this.division.trim(),
                zona: this.zona.trim(),
                capacidad: this.capacidad +" "+ this.unidad_capacidad,
                unidad_capacidad: this.unidad_capacidad + this.unidad_capacidad,
                tension_conexion: this.tension_conexion,
                tipo_tecnologia: this.tecnologia,
                cotizacion_id: localStorage.getItem('idcotizacion')
            };
        },
        async submitForm() {
            if (!this.validar()) return;
            this.isLoading = true;
            try {
                await axios.post(this.$rutaServer + 'guardarOficioResolutivo', this.armarDatos(), this.config());
                Swal.fire('Guardado!', 'Los datos del oficio se guardaron correctamente.', 'success');
                this.mostrarInformacion();
            } catch (error) {
                this.isLoading = false;
                console.error(error);
                Swal.fire('Error!', 'Hubo un problema al guardar los datos del oficio.', 'error');
            }
        },
        async submitFormActualizar() {
            if (!this.validar()) return;
            this.isLoading = true;
            try {
                const datos = this.armarDatos();
                datos.id = this.id;
                await axios.post(this.$rutaServer + 'actualizarOficioResolutivo', datos, this.config());
                Swal.fire('Actualizado!', 'Los datos del oficio se actualizaron correctamente.', 'success');
                this.mostrarInformacion();
            } catch (error) {
                this.isLoading = false;
                console.error(error);
                Swal.fire('Error!', 'Hubo un problema al actualizar los datos del oficio.', 'error');
            }
        },
        async mostrarInformacion() {
            this.isLoading = true;
            const idcotizacion = localStorage.getItem('idcotizacion');
            try {
                const response = await axios.post(this.$rutaServer + 'consultarOficioResolutivo', { id_cotizacion: idcotizacion }, this.config());
                const oficio = response.data.data && response.data.data[0];
                let [numero, unidad] = oficio.capacidad.split(" ");
                if (oficio) {
                    
                    
                    this.id = oficio.id;
                    this.numero_oficio = oficio.numero_oficio || '';
                    this.sin_numero = this.numero_oficio === 'S/N';
                    this.fecha_emision = oficio.fecha_oficio || '';
                    this.dependencia = oficio.emitido_por || '';
                    this.division = oficio.division || '';
                    this.zona = oficio.zona || '';
                    this.capacidad = numero ?? '';
                    this.unidad_capacidad = unidad ?? 'KW';
                    this.tension_conexion = oficio.tension_conexion ?? '';
                    this.tecnologia = oficio.tipo_tecnologia || '';
                    this.botonGuardar = false;
                } else {
                    this.botonGuardar = true;
                }
            } catch (error) {
                this.botonGuardar = true;
            } finally {
                this.isLoading = false;
            }
        }
    }
}
</script>
